export const createIcon = (iconClass, marginRight = '5px') => {
  const icon = document.createElement('i');
  icon.className = iconClass;
  icon.style.marginRight = marginRight;
  return icon;
};

export const showCopiedTextPopover = (element) => {
  element.setAttribute('data-bs-toggle', 'popover');
  element.setAttribute('data-bs-content', 'Copied!');
  element.setAttribute('data-bs-placement', 'top');
  element.setAttribute('data-bs-trigger', 'manual');

  const popover = new bootstrap.Popover(element);
  popover.show();

  setTimeout(() => popover.hide(), 1000);
};

export const createSelectOption = (value, text, disabled, selected) => {
  const option = document.createElement('option');
  option.value = value;
  option.textContent = text;
  option.disabled = disabled;
  option.selected = selected;

  return option;
};

export const setDropdownValue = (selector, value) => $(selector).val(value).trigger('change');

export const resetDropdowns = (selectors) => selectors.forEach(selector => setDropdownValue(selector, null));

export const updateValuesAndTrigger = (selectors, value) => selectors.forEach(selector => setDropdownValue(selector, value));
